import { currentSnackbarState } from '@databases/snackbar/snackbar';
import { useEffect } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../i18n';

const snackbarMessageId = 'content-sync-status';

export const useContentVersionHeader = (
  versionName: string | undefined,
  versionId: string | undefined
) => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (versionName && versionId && versionId !== 'latest') {
      // After loading a new version, we want to let the user know if they are viewing a historic version
      const viewingHistoricVersionMessage = formatMessage(
        messages['snackbar-message.viewingHistoricVersion'],
        {
          versionName
        }
      );
      currentSnackbarState.setMessage(viewingHistoricVersionMessage, {
        id: snackbarMessageId
      });
    } else {
      currentSnackbarState.clearMessage(snackbarMessageId);
    }
  }, [formatMessage, versionName, versionId]);
};
